import {useState } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";

import "./MySubscriptionsAndTokens.css";

import SideMenu from "../../components/SideMenu";
import ClassTokens from "./ClassTokens";
import Subscriptions from "./Subscriptions";

export default function MySubscriptionsAndTokens() {
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthContext();
  const [activeModal, setActiveModal] = useState(false);
  const [selectedSub, setSelectedSub] = useState([]);

  const [cards, setCards] = useState([]);
  const [failedpaymentId, setFailedpaymentId] = useState(0);

  const [currentView, setCurrentView] = useState("ClassTokens");

  const handleSelect = (sub) => {
    setSelectedSub(sub);
    setActiveModal(true);
  };

  const renderComponent = () => {
    switch (currentView) {
      case "ClassTokens":
        return <ClassTokens />;
      case "Subscriptions":
        return <Subscriptions />;

      default:
        return null;
    }
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div className="container">
        <div className="col showAt1300 ">
          <div className="blueBanner ">
            <p className="text-white p-2  mb-0 fw-bold fontSize20 ">
              Subscriptions And Tokens
            </p>
          </div>
          <div className="showAt450 text-center">
          <button
                onClick={() => setCurrentView("ClassTokens")}
                className="settings-menu-button-stacked"
              >
              Show Class Tokens
              </button> <br></br>
              <button
                onClick={() => setCurrentView("Subscriptions")}
                    className="settings-menu-button-stacked"
              >
              Show Subscriptions
              </button><br></br>
             
          </div>
          <div className="hideAt450">
            {" "}
            <div className="d-flex justify-content-end ">
              <button
                onClick={() => setCurrentView("ClassTokens")}
                className="settings-menu-button"
              >
                Class Tokens
              </button>
              <button
                onClick={() => setCurrentView("Subscriptions")}
                className="settings-menu-button"
              >
                Subscriptions
              </button>
          
            </div>
          </div>

          <div>{renderComponent()}</div>
        </div>
        <div className="row hideAt1300">
          <div className="col-3 side-menu-container">
            <SideMenu />
          </div>
          <div className="col sideBarMargin my-2 p-0 ">
            <div className="blueBanner ">
              <p className="text-white p-3  mb-0 fw-bold fontSize20 ">
                Subscriptions And Tokens
              </p>
            </div>
            <div className="d-flex justify-content-end">
              <button
                onClick={() => setCurrentView("ClassTokens")}
                className="settings-menu-button"
              >
                Class Tokens
              </button>
              <button
                onClick={() => setCurrentView("Subscriptions")}
                className="settings-menu-button"
              >
                Subscriptions
              </button>
        
            </div>
            <div>{renderComponent()}</div>
          </div>
        </div>
      </div>
    );
  }
}
